import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaPhone, FaEnvelope, FaYoutube } from 'react-icons/fa';

const Footer = () => {
  const services = [
    'Website Design',
    'Mobile Experience',
    'Digital Marketing',
    'UI/UX Design',
    'E-commerce',
    'AI & Machine Learning'
  ];

  const quickLinks = [
    { name: 'Home', href: '/' },
    { name: 'About Us', href: '/about' },
    { name: 'Services', href: '/services' },
    { name: 'Contact', href: '/contact' },
  ];

  return (
    <footer className="bg-gradient-to-br from-[#22446b] via-[#2d5a8a] to-[#338edc] text-white pt-20 font-opensans border-t border-white/5 relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#338edc] to-[#22446b]"></div>
        <div className="absolute -top-20 -right-20 w-96 h-96 bg-white/5 rounded-full blur-3xl pointer-events-none"></div>

      <div className="container mx-auto px-6 lg:px-8 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-8">
            <Link to="/" className="flex items-center space-x-2">
              <div className="bg-white p-2 rounded-lg">
                <img 
                  src="/logo.png" 
                  alt="SutraSync Logo" 
                  className="h-16 w-auto object-contain"
                />
              </div>
            </Link>
            <p className="text-white/80 leading-relaxed text-sm">
              We provide perfect IT solutions & technology for any startups. 
              Bringing innovative digital experiences to help your business grow and succeed in the digital era.
            </p>
            <div className="flex space-x-3">
              <a href="https://www.facebook.com/share/1GLCUxZKbX/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-[#1877F2] rounded-lg flex items-center justify-center hover:opacity-90 text-white transition-all duration-300 group">
                <FaFacebookF size={16} className="group-hover:scale-110 transition-transform" />
              </a>
              <a href="https://www.linkedin.com/company/sutra-sync-technology" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-[#0A66C2] rounded-lg flex items-center justify-center hover:opacity-90 text-white transition-all duration-300 group">
                <FaLinkedinIn size={16} className="group-hover:scale-110 transition-transform" />
              </a>
              <a href="https://www.instagram.com/sutrasync_techonologies/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gradient-to-br from-[#833AB4] via-[#E1306C] to-[#F77737] rounded-lg flex items-center justify-center hover:opacity-90 text-white transition-all duration-300 group">
                <FaInstagram size={16} className="group-hover:scale-110 transition-transform" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white text-xl font-rajdhani font-bold mb-8 relative inline-block">
              Our Services
              <span className="absolute -bottom-2 left-0 w-12 h-1 bg-[#338edc] rounded-full"></span>
            </h3>
            <ul className="space-y-4">
              {services.map((service, index) => (
                <li key={index}>
                  <Link 
                    to="/services" 
                    className="text-white/70 hover:text-white transition-colors flex items-center group text-sm"
                  >
                    <span className="w-1.5 h-1.5 bg-[#338edc] rounded-full mr-3 group-hover:bg-white transition-colors"></span>
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Addresses */}
          <div>
            <h3 className="text-white text-xl font-rajdhani font-bold mb-8 relative inline-block">
              Our Locations
              <span className="absolute -bottom-2 left-0 w-12 h-1 bg-[#338edc] rounded-full"></span>
            </h3>
            <div className="space-y-6">
              {/* Headquarters */}
              <div>
                <h4 className="text-white font-rajdhani font-semibold mb-2 text-sm">Headquarters</h4>
                <p className="text-white/70 text-sm leading-relaxed">
                  Scintilla Apartment, 23, 1st Main Rd<br />
                  4th Phase, Yelahanka New Town<br />
                  Bengaluru, Karnataka 560064<br />
                  India
                </p>
              </div>
              {/* Branch */}
              <div>
                <h4 className="text-white font-rajdhani font-semibold mb-2 text-sm">Branch Office</h4>
                <p className="text-white/70 text-sm leading-relaxed">
                  402, 4th Floor, Global Business Park<br />
                  Mehrauli-Gurgaon Rd, Sikanderpur<br />
                  Sector 26, Gurugram<br />
                  Haryana 122002, India
                </p>
              </div>
            </div>
          </div>

          {/* YouTube Subscribe / Contact */}
          <div>
            <h3 className="text-white text-xl font-rajdhani font-bold mb-8 relative inline-block">
              Subscribe
              <span className="absolute -bottom-2 left-0 w-12 h-1 bg-[#338edc] rounded-full"></span>
            </h3>
            <p className="text-white/70 text-sm mb-6">
              Subscribe to our YouTube channel for the latest updates.
            </p>
            <a 
              href="https://www.youtube.com/@sutrasyncindia" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center justify-center space-x-3 bg-[#FF0000] hover:bg-[#CC0000] text-white rounded-lg py-3 px-6 transition-all duration-300 transform hover:scale-105 mb-8 group"
            >
              <FaYoutube size={24} className="group-hover:scale-110 transition-transform" />
              <span className="font-rajdhani font-semibold">Subscribe on YouTube</span>
            </a>
            
            <div className="space-y-3 pt-4 border-t border-white/5">
                <div className="flex items-center space-x-3 text-sm text-white/70">
                    <FaPhone className="text-[#338edc]" />
                    <span>+91 7483961283</span>
                </div>
                <div className="flex items-center space-x-3 text-sm text-white/70">
                    <FaEnvelope className="text-[#338edc]" />
                    <span>info@sutrasync.com</span>
                </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/15 bg-#22446b]">
        <div className="container mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white text-sm font-medium">
              © {2026} Sutrasync. All rights reserved.
            </p>
            <div className="flex space-x-8 text-sm">
              <Link to="#" className="text-white hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <Link to="#" className="text-white hover:text-white transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;